// polyfill all `core-js` features:
import 'core-js';
import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { Route } from 'react-router';
import { HashRouter } from 'react-router-dom';

import App from './components/App';
import configureStore from './store/configureStore';

import { lookForCookie } from './actions/authenticationActions';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-bootstrap-table/dist/react-bootstrap-table.min.css';
import 'antd/dist/antd.css';
import 'font-awesome/css/font-awesome.min.css';
import './styles/antd.css';
import './styles/header.css';
import './styles/custom.css';


import initialState from './reducers/initialState';
const store = configureStore(initialState);
store.dispatch(lookForCookie());

render(
  <Provider store={store}>
    <HashRouter>
      <Route path="/" component={App} />
    </HashRouter>
  </Provider>,
  document.getElementById('root')
);
